var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lymphomap_main"},[_c('div',{staticClass:"container coming_soon_wrp"},[_c('h3',{attrs:{"data-text":"Coming soon..."}},[_vm._v("Coming soon...")])])])
}]

export { render, staticRenderFns }